import { Modal } from 'bootstrap';
var capsulesConfigs = [
    {
        TITLE: "Cette section permet d'en apprendre davantage sur les étapes et astuces de l'opération de découpage des secteurs au module cartographique offert par le MEQ",
        VIDEOS: [
            {
                TITLE: "Informations pertinentes à retenir avant de débuter le découpage des secteurs",
                TEXT: "",
                SRC: "documents/1_Informations.mp4",
            }, {
                TITLE: "Ajout d'un nouveau secteur",
                TEXT: "",
                SRC: "documents/2_Ajout_secteur.mp4",
            }, {
                TITLE: "Ajout d'une ligne délimitant un nouveau secteur ou des secteurs modifiés",
                TEXT: "",
                SRC: "documents/3_Ajout_ligne.mp4",
            }, {
                TITLE: "Étapes de modification d'un secteur existant",
                TEXT: "",
                SRC: "documents/4_Modif.mp4",
            }, {
                TITLE: "Consultation des statistiques pour un groupe de codes postaux préalablement sélectionnés",
                TEXT: "",
                SRC: "documents/5_Stats.mp4",
            }, {
                TITLE: "Travailler avec le tableau de données",
                TEXT: "",
                SRC: "documents/6_Donnees.mp4",
            }, {
                TITLE: "Utiliser l'outil d'itinéraire",
                TEXT: "",
                SRC: "documents/7_Itineraire.mp4",
            }
        ]
    }
   
];

var capsulesContainerHTML = '<div class="modal fade" id="CapsulesModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">' +
                                '<div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">' +
                                    '<div class="modal-content">' +
                                        '<div class="modal-header">' +
                                            '<h1 class="modal-title fs-5" id="exampleModalLabel">Capsules d\'aide pour le découpage des secteurs de prévisions d\'effectifs scolaires</h1>' +
                                            '<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>' +
                                        '</div>' +
                                        '<div class="modal-body">' +
                                            '<div class="accordion" id="CapsulesModal-accordion">' +
                                                _.map(capsulesConfigs, function(capsuleConfigs, idx){
                                                    return '<div class="accordion-item">' +
                                                                '<h2 class="accordion-header">' +
                                                                    '<button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#CapsulesModal-accordion-' + idx + '" aria-expanded="true" aria-controls="CapsulesModal-accordion-' + idx + '">' + capsuleConfigs.TITLE + ' (' + capsuleConfigs.VIDEOS.length + ' vidéos)' + '</button>' +
                                                                '</h2>' +
                                                                '<div id="CapsulesModal-accordion-' + idx + '" class="accordion-collapse collapse show" data-bs-parent="#CapsulesModal-accordion">' +
                                                                    '<div class="accordion-body">' +
                                                                        '<div class="container-fluid">' +
                                                                            '<div class="row row-cols-1 row-cols-md-3 g-4">' +
                                                                                _.map(capsuleConfigs.VIDEOS, function(videoConfigs){
                                                                                    return '<div class="col">' +
                                                                                                '<div class="card h-100">' +
                                                                                                    '<video class="card-img-top" controls src="' + videoConfigs.SRC + '"></video>' +
                                                                                                    '<div class="card-body">' +
                                                                                                        '<h5 class="card-title">' + videoConfigs.TITLE + '</h5>' +
                                                                                                        '<p class="card-text">' + videoConfigs.TEXT + '</p>' +
                                                                                                    '</div>' +
                                                                                                '</div>' +
                                                                                            '</div>';
                                                                                }).join("") +
                                                                            '</div>' +
                                                                        '</div>' +
                                                                    '</div>' +
                                                                '</div>' +
                                                            '</div>';
                                                }).join("") +
                                            '</div>' +
                                        '</div>' +
                                        '<div class="modal-footer">' +
                                            '<button type="button" class="btn btn-primary" data-bs-dismiss="modal">Carte</button>' +
                                        '</div>' +
                                    '</div>' +
                                '</div>' +
                            '</div>';

export default class Capsules {
    constructor(){
        $("body").append(capsulesContainerHTML);
        new Modal('#CapsulesModal');
    }
}